export function downloadCSV(csvStr: string, name: string) {
  try {
    const hiddenElement = document.createElement('a');

    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvStr);
    hiddenElement.target = '_blank';
    hiddenElement.download = `${name}.csv`;
    hiddenElement.click();
  } catch (error) {
    console.error(`Failed to begin CSV download`, error);
  }
}
